export enum AssetType {
  png = "image/png",
  jpeg = "image/jpeg",
  jpg = "image/jpg",
  tiff = "image/tiff",
  webp = "image/webp",
  pdf = "application/pdf",
  psd = "image/vnd.adobe.photoshop",
  mp4 = "video/mp4",
}
